import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
import { useMessageEvent } from '@post-office/message-lifecycle';
import type { ClickedElementAttributes } from '@post-office/shared-contracts/message-instance-event';
import { useCallback } from 'react';

export const useActionMessageClicked = (
	onMessageClick: (e: React.MouseEvent<HTMLElement>) => void,
	clickedElement: ClickedElementAttributes,
): {
	handleClick: (e: React.MouseEvent<HTMLElement>) => void;
} => {
	const { messageClicked, messageDismissed } = useMessageEvent();
	const { messageInstanceClicked } = useMessageInstanceEvent();

	const handleClick = useCallback(
		(e: React.MouseEvent<HTMLElement>): void => {
			messageClicked().catch(() => {});
			messageInstanceClicked({
				messageEventType: 'clicked',
				clickedElement,
				action: {
					actionType: 'acknowledge',
				},
				additionalMetadataFromFrontend: {},
			}).catch(() => {});
			onMessageClick(e);

			// Dismiss Create Whiteboard and Create Page message instances after the user clicks on the action
			// This is so that if the user reloads the page, the message is not shown again.
			// Otherwise, there is a delay of 5 mins due to us using cached tap-sidecar with a 5-min TTL so the latest TAP trait info won't be retrieved till then
			if (
				clickedElement.clickIdentifier.includes('CREATE_WHITEBOARD') ||
				clickedElement.clickIdentifier.includes('CREATE_PAGE')
			) {
				messageDismissed().catch(() => {});
			}
		},
		[clickedElement, messageClicked, messageInstanceClicked, onMessageClick],
	);

	return { handleClick };
};
